/**
 * JKL: close search when clicking the dimmed area outside the panel.
 * Complements SearchModal’s #SearchModal-Overlay listener (global.js).
 */
(function () {
	const modal = document.getElementById("search-modal");
	if (!modal || typeof modal.close !== "function") return;

	modal.addEventListener("click", (event) => {
		if (!modal.classList.contains("active")) return;

		const panel = modal.querySelector(".search__content");
		if (panel && panel.contains(event.target)) return;

		modal.close();
	});
})();
